<template>
  <div class="DistributingMonitor mainPageBg">
    <div class="leftBox">
      <TreeMenu @getActiveItem="getActiveItem" :pageName="'配电系统'" />
    </div>
    <div class="rightBox">
      <div class="state ashComWrap">
        <div class="comTitle">
          <h3>监控状态</h3>
        </div>
        <div class="comContentBox state-content">
          <HeadTips v-if="state?.length" :listData="state" />
          <el-empty
            v-else
            class="empty"
            :image-size="80"
            description="暂无数据"
          ></el-empty>
        </div>
      </div>
      <div class="container">
        <template v-if="listData.length">
          <div class="container-videos">
            <VideoCards :listData="splitArray"/>
          </div>
          <div v-if="listData.length > splitNum" class="container-pagination">
            <el-pagination
              :current-page="currentPage"
              @current-change="handleCurrentChange"
              hide-on-single-page
              layout="prev, pager, next"
              :page-size="splitNum"
              :total="listData.length"
            >
            </el-pagination>
          </div>
        </template>
        <el-image
          v-else
          style="width: 100%; height: 100%"
          :src="require('@/assets/images/video/noVideo.svg')"
          fit="cover"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
import TreeMenu from "@/components/zixitong/TreeMenu";
import HeadTips from "@/components/HeadTips/HeadTips";
import VideoCards from "@/components/VideoPlayer/VideoCards";
import api from "@/api";
export default {
  name: "DistributingMonitor",
  props: {},
  components: { TreeMenu, HeadTips,VideoCards },
  data() {
    return {
      assetId: "",
      state: [
        {
          name: "全部",
          value: 0,
        },
        {
          name: "在线",
          value: 0,
        },
        {
          name: "离线",
          value: 0,
        },
      ],
      listData: [],
      currentPage: 1,
      splitNum: 2,
    };
  },
  computed: {
    splitArray: function () {
      return this.listData.slice(
        (this.currentPage - 1) * this.splitNum,
        this.currentPage * this.splitNum
      );
    },
  },
  methods: {
    getActiveItem(data) {
      console.log("----getActiveItem--data--", data);
      this.assetId = data.id;
      this.getCameraInfo(data.id);
    },
    async getCameraInfo(assetId) {
      const res = await api.DSGetDistributingPvList({
        assetId: assetId || this.assetId,
        deviceTypes: "枪机摄像头",
        page: 0,
        pageSize: 10000,
        needAll: true,
      });
      if (res && res.data.code == 200) {
        let on = 0;
        let off = 0;
        const newData = res.data.data.data.map((item) => {
          if (item?.active) {
            item.status = "active";
            on++;
          } else {
            item.status = "offline";
            off++;
          }
          return item;
        });
        this.listData = newData;
        const all = on + off;
        this.state = [
          {
            name: "全部",
            value: all,
          },
          {
            name: "在线",
            value: on,
          },
          {
            name: "离线",
            value: off,
          },
        ];
        //处理传入界面的id，初始选中
        // if (!!this.$route.params.id) {
        //   const defaultId = this.$route.params.id
        //   const index = this._.findIndex(newData, function (o) { return o.id === defaultId; })
        //   this.activeIndex = index
        //   const activeItem = newData[index]
        //   this.activeItem = {
        //     ...activeItem,
        //     url: `ws://127.0.0.1:8888/rtsp?url=rtsp://${activeItem?.RTSP || ""}`,
        //     urlBack: `ws://127.0.0.1:8888/rtsp?url=rtsp://${(activeItem?.RTSP || "").replace('Channels', 'tracks')}?${this.timeFormatStr}`
        //   }
        // }
      } else {
        console.log("获取监控列表失败");
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.DistributingMonitor {
  @include setFlexBetween;
  .leftBox {
    @include setMenuWH;
  }
  .rightBox {
    @include setCenterWH;
    background-color: #f7f7f7;
    .state {
      background-color: #ffffff;
      padding: 10px;
      border-radius: 6px;
      height: 135px;
      &-content{
        width: 600px;
      }
    }
    .container {
      margin-top: 12px;
      height: calc(100% - 147px);
      &-videos {
        height: calc(100% - 50px);
      }
      &-pagination {
        height: 20px;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
}
</style>
